export const STATION_TAB = 'station-tab';
export const USER_TAB = 'user-tab';
